import {Button, ButtonProps} from '@mui/material';
import {forwardRef} from 'react';

export type LegacyGreenButtonProps = ButtonProps;

const LegacyGreenButton = forwardRef<HTMLButtonElement, LegacyGreenButtonProps>(
  ({className, color = 'primary', variant = 'contained', ...buttonProps}, ref) => (
    <Button
      ref={ref}
      className={['ha-btn-green', className].filter(Boolean).join(' ')}
      color={color}
      variant={variant}
      {...buttonProps}
    />
  ),
);

LegacyGreenButton.displayName = 'LegacyGreenButton';

export default LegacyGreenButton;
